import type { DateRangeValue, DateValue } from '../index';

function getIsDateValuesEqual(left: DateValue, right: DateValue) {
  return left.toString() === right.toString();
}

export function getIsDateRangesEqual(
  left: DateRangeValue,
  right: DateRangeValue,
): boolean {
  return (
    getIsDateValuesEqual(left.start, right.start) &&
    getIsDateValuesEqual(left.end, right.end)
  );
}
